import {creates, hoistCmp} from '@xh/hoist/core';
import {dashContainer} from '@xh/hoist/desktop/cmp/dash';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {MarketsTabModel} from './MarketsTabModel';

export const marketsTab = hoistCmp.factory<MarketsTabModel>({
    model: creates(MarketsTabModel),
    render({model}) {
        return panel(dashContainer());
    }
});
